var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerCss"},[_c('nav-header'),_c('img',{staticClass:"act-img",attrs:{"src":_vm.backImg},on:{"click":_vm.goHost}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }